export default __webpack_public_path__ + "static/poster-ro-d63da798d568e1e32458dedb40a445c4.png";